export const locale = {
  lang: 'nl',
  data: {
    'NOMBREIDIOMAS': {
      'es': 'Spanish',
      'en': 'English',
      'pt': 'Portuguese',
      'zh1': 'Traditional Chinese',
      'zh2': 'Simplified Chinese',
      'tr': 'Turkish',
      'vi': 'Vietnamese',
      'ja': 'Japanese',
      'my': 'Malay',
      'ro': 'Romanian',
      'ru': 'Russian',
      'fr': 'French',
      'de': 'German',
      'it': 'Italian',
      'nl':'Dutch',
      'ms': 'Maleis',
      'hi': 'Hindi',
      'id': 'Indonesisch',
      'ua': 'Oekraïens',
      'ge': 'Georgisch',
      'uz': 'Oezbeeks',
      'az': 'Azeri',
      'kk': 'Kazachstan',
      'hr': 'Kroatisch',
      'ar': 'Arabisch',
      'mk': 'Macedonisch',
      'lv': 'Lets',
      'pr': 'Portuguese (Portugal)',
      'th': 'Thai',
    }
  }
};
